const pluralRules = new Intl.PluralRules("en-US");

export function pluralize(
  count: number,
  singular: string,
  plural: string,
  includeCount = true
): string {
  const grammaticalNumber = pluralRules.select(count);
  switch (grammaticalNumber) {
    case "one":
      return includeCount ? `${count} ${singular}` : singular;
    case "other":
      return includeCount ? `${count} ${plural}` : plural;
    default:
      throw new Error("Unknown: " + grammaticalNumber);
  }
}
